import React, { useEffect } from 'react';
import styled from 'styled-components';

import Column from 'components/common/Column';
import Row from 'components/common/Row';
import {
  IconArrow,
  ICON_PLUS_BLACK,
  ICON_PLUS_GRAY,
  ICON_PRODUCTLIST_COPY,
  ICON_PRODUCTLIST_REGIST,
} from 'assets/icons';
import Text from 'components/common/Text';
import { MeData } from 'graphQL/Auth/types';
import { ProductState } from 'types/api';
import ProductCard from './ProductCard';
import Divider from 'components/Divider';
import { useProductRegistModalHooks } from '../hooks/useProductRegistModalHooks';
import { InView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
import { PRODUCT_REGIST_PATH } from 'constants/path';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import HackleManager from 'utils/hackle';
import IconClose from 'assets/icons/IconClose';
import CommonImage from 'components/common/CommonImage';

const MoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  padding: 8px 12px;

  border-radius: 12px;
  background-color: #f4f4f5;
`;

interface ProductRegistModalIProps {
  myInfo: MeData;
  isMobile: boolean;
  onClose: () => void;
}

const ProductRegistModal: React.FC<ProductRegistModalIProps> = props => {
  const { myInfo, isMobile, onClose } = props;
  const navigate = useNavigate();

  const isEditingProduct = myInfo.me.host.productInfo.counts.find(
    item => item.status === ProductState.EDITING,
  );
  const {
    productList,
    isLoadMore,
    viewType,
    setViewType,
    handleLoadMoreProductList,
    handleSetRegistProductList,
    handleGetCopyProductList,
  } = useProductRegistModalHooks(myInfo);

  const renderEditingProductList = (): JSX.Element => {
    if (isEditingProduct !== undefined) {
      return (
        <React.Fragment>
          <Text color="#1b1c1e" size="18px" weight={600}>
            등록중인 상품
          </Text>
          {productList && (
            <Column gap="12px">
              {productList.product.products.edges.map((item, idx) => {
                return <ProductCard key={idx} item={item} type="update" />;
              })}
            </Column>
          )}
          {!isLoadMore && (
            <MoreButton onClick={handleLoadMoreProductList}>
              <IconClose
                width="16px"
                height="16px"
                color="#414B56"
                style={{ transform: 'rotate(45deg)' }}
              />
              <Text color="#1b1c1e" size="16px" style={{ cursor: 'pointer' }}>
                더보기
              </Text>
            </MoreButton>
          )}
          <Divider />
        </React.Fragment>
      );
    }

    return <></>;
  };

  const renderRegistSelectForm = (): JSX.Element => {
    return (
      <Column gap="32px" align="flex-start">
        <Row
          gap="16px"
          justifyContent="space-between"
          style={{ width: '100%', cursor: 'pointer' }}
        >
          <Row
            gap="16px"
            onClick={() => {
              HackleManager.logProductCreateTypeClick('새로운 상품 등록하기');
              navigate(`${PRODUCT_REGIST_PATH}/draft`);
            }}
          >
            <img src={ICON_PRODUCTLIST_REGIST} alt="icon productlist regist" />
            <Text color="#414B56" size="16px" weight={400}>
              새로운 상품 등록하기
            </Text>
          </Row>
          <IconArrow color="#414B56" />
        </Row>
        <Row
          gap="16px"
          justifyContent="space-between"
          style={{ width: '100%', cursor: 'pointer' }}
        >
          <Row
            gap="16px"
            onClick={() => {
              HackleManager.logProductCreateTypeClick('기존 상품 복사하기');
              handleGetCopyProductList();
            }}
          >
            <img src={ICON_PRODUCTLIST_COPY} alt="icon productlist regist" />
            <Text color="#414B56" size="16px" weight={400}>
              기존 상품 복사하기
            </Text>
          </Row>
          <IconArrow color="#414B56" />
        </Row>
      </Column>
    );
  };

  const renderCopyProductList = (): JSX.Element => {
    return (
      <React.Fragment>
        {productList && (
          <Column gap="12px">
            {productList.product.products.edges.map((item, idx) => {
              return <ProductCard key={idx} item={item} type="copy" />;
            })}
            <InView
              onChange={inView => {
                if (
                  inView &&
                  productList.product.products.pageInfo.hasNextPage
                ) {
                  handleLoadMoreProductList();
                }
              }}
            ></InView>
          </Column>
        )}
      </React.Fragment>
    );
  };

  return (
    <ModalContainer
      isAbled={true}
      isMobile={isMobile}
      isBottomSheet={true}
      onClose={onClose}
      onClick={() => {}}
    >
      <Column gap="12px" align="flex-start" style={{ padding: '0 20px 32px' }}>
        <Row
          justifyContent="space-between"
          style={{
            position: 'sticky',
            top: 0,
            padding: '24px 0',
            width: '100%',
            background: '#fff',
          }}
        >
          <Text color="#1B1C1E" size="20px" weight={600}>
            {viewType === 'regist' ? '상품 등록하기' : '상품 복사하기'}
          </Text>
          <IconClose
            color="#70737C"
            width="24px"
            height="24px"
            onClick={() => {
              if (viewType === 'regist') {
                onClose();

                return;
              }

              setViewType('regist');
              handleSetRegistProductList();
            }}
          />
        </Row>
        {viewType === 'regist' ? (
          <Column gap="24px" align="flex-start">
            {renderEditingProductList()}
            {renderRegistSelectForm()}
          </Column>
        ) : (
          renderCopyProductList()
        )}
      </Column>
    </ModalContainer>
  );
};

export default ProductRegistModal;
